import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";

const IconShare = (props: IconProps) => (
  <svg
    width={props.width || 22}
    height={props.height || 22}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.6667 4.1665V7.49984C5.83333 8.33317 3.33333 12.4998 2.5 16.6665C4.58333 13.7498 7.5 12.4165 11.6667 12.4165V15.8332L17.5 9.99984L11.6667 4.1665ZM13.3333 8.1915L15.1417 9.99984L13.3333 11.8082V10.7498H11.6667C9.94167 10.7498 8.39167 11.0665 6.95 11.5415C8.11667 10.3832 9.61667 9.47484 11.9 9.1665L13.3333 8.9415V8.1915Z"
      fill={props.color || "white"}
    />
  </svg>
);

export default IconShare;
